export default __webpack_public_path__ + "static/main-08dc2eb4921470bcbbc6600b4c9f19b4.png";